import React from "react"
import { motion } from "framer-motion"
import { Mail, Phone, MapPin } from "lucide-react"

export default function ContactInfo({ businessData, activeTab, setActiveTab }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <h2 className="text-3xl font-bold mb-6">Contact Information</h2>

      {/* Tabs */}
      <div className="flex space-x-4 mb-8">
        {businessData.map((business, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
              activeTab === index ? "bg-orange-600 text-white" : "bg-gray-200 text-gray-600 hover:bg-gray-300"
            }`}
          >
            {business.name}
          </button>
        ))}
      </div>

      {/* Contact Info Cards */}
      <div className="space-y-6">
        {[
          { icon: Mail, label: "Email", value: businessData[activeTab].email },
          { icon: Phone, label: "Phone", value: businessData[activeTab].phone },
          { icon: MapPin, label: "Locations", value: businessData[activeTab].locations },
        ].map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white p-6 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-orange-50 rounded-lg">
                <item.icon className="w-6 h-6 text-orange-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{item.label}</h3>
                <p className="text-gray-600 mt-1">{item.value}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  )
}

